<template>
  <div>
    <div class="sidebar-container">
      <!-- 侧边栏内容 -->
      <!-- @click="switchType(0)" -->
      <div
        style="height: 100px;width: 100px;"
        :class="{ 'sidebar-active': active == 0 }"
        class="center-just"
      >
        <div
          class="column-space"
          style="height: 60px;"
          @mousemove="sidebar(0)"
          @mouseout="out()"
        >
          <el-image
            :src="$domain + 'static/noten/website/home/contact_survice.png'"
            style="width: 24px;height: 21px;align-self: center;"
          ></el-image>
          联系客服
        </div>
      </div>
      <div class="center-just" style="height: 1px;">
        <div class="bar"></div>
      </div>
      <div
        style="height: 100px;width: 100px;"
        :class="{ 'sidebar-active': active == 1 }"
        class="center-just"
        @mousemove="sidebar(1)"
        @mouseout="out()"
      >
        <div class="column-space" style="height: 60px;">
          <el-image
            :src="$domain + 'static/noten/website/home/contact_survice.png'"
            style="width: 24px;height: 21px;align-self: center;"
          ></el-image>
          小程序
        </div>
      </div>
      <div class="center-just" style="height: 1px;">
        <div class="bar"></div>
      </div>
      <div
        style="height: 100px;width: 100px;"
        :class="{ 'sidebar-active': active == 2 }"
        class="center-just"
        @mousemove="sidebar(2)"
        @mouseout="out()"
      >
        <div class="column-space" style="height: 60px;">
          <el-image
            :src="$domain + 'static/noten/website/home/contact_survice.png'"
            style="width: 24px;height: 21px;align-self: center;"
          ></el-image>
          下载App
        </div>
      </div>
      <div class="center-just" style="height: 1px;">
        <div class="bar"></div>
      </div>
      <div
        style="height: 100px;width: 100px;"
        :class="{ 'sidebar-active': active == 3 }"
        class="center-just"
        @mousemove="sidebar(3)"
        @mouseout="out()"
      >
        <div class="column-space" style="height: 60px;">
          <el-image
            :src="$domain + 'static/noten/website/home/contact_survice.png'"
            style="width: 24px;height: 21px;align-self: center;"
          ></el-image>
          关注公众号
        </div>
      </div>
    </div>
    <div>
      <div class="test1111" v-if="sidebarActive == 0">
        <div class="column">
          <el-image
            :src="
              $domain +
                'static/noten/website/home/QRcode/微信客服holiday9580.jpg'
            "
            style="width: 150px;height: 150px;align-self: center;"
          ></el-image>
          <span class="about-info center" style="margin-top: 20px;"
            >客服微信</span
          >
        </div>
      </div>
      <div class="test1111" v-if="sidebarActive == 1">
        <div class="column">
          <el-image
            :src="$domain + 'static/noten/website/home/QRcode/同步学860.jpg'"
            style="width: 150px;height: 150px;align-self: center;"
          ></el-image>
          <span class="about-info center" style="margin-top: 20px;"
            >扫码使用小程序</span
          >
        </div>
      </div>
      <div class="test1111" v-if="sidebarActive == 2">
        <div class="column">
          <el-image
            :src="$domain + 'static/noten/website/home/QRcode/口袋网校400.png'"
            style="width: 150px;height: 150px;align-self: center;"
          ></el-image>
          <span class="about-info center" style="margin-top: 20px;"
            >扫描二维码下载口袋网校APP</span
          >
        </div>
      </div>
      <div
        class="test1111"
        style="height: 200px;width: 200px;background-color: #ffffff"
        v-if="sidebarActive == 3"
      >
        <div>
          <div class="column">
            <el-image
              :src="$domain + 'static/noten/website/home/QRcode/公众号860.jpg'"
              style="width: 150px;height: 150px;"
            ></el-image>
            <span class="about-info center" style="margin-top: 10px;"
              >扫描二维码关注公众号</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Programming from "@/views/home/programming";
import Applets from "@/views/home/applet";
import Apps from "@/views/home/apps";
import Course from "@/views/home/course";
export default {
  components: { Programming, Applets, Apps, Course },
  data() {
    return {
      active: 0,
      sidebarActive: 4,
      typeList: ["次元口袋编程", "口袋英语同步学", "口袋网校App", "编程视频课"]
    };
  },
  methods: {
    switchType(index) {
      this.active = index;
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    sidebar(index) {
      this.sidebarActive = index;
    },
    out() {
      this.sidebarActive = 4;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 10002;
  /* 其他样式 */
  background-color: #ffffff;
  box-shadow: 5px 25px 25px 5px rgba(127, 136, 170, 0.158);
  border-radius: 0px 50px 50px 0px !important;
  color: #1966ff;
  font-family: Microsoft YaHei;
  font-size: 16px;
  cursor: pointer;
}
.test1111 {
  position: fixed;
  top: 50%;
  right: 110px;
  transform: translateY(-50%);
  z-index: 10002;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.sidebar-active {
}
.bar {
  height: 1px;
  background-color: rgb(220, 226, 226);
  width: 80%;
}
.center-just {
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 15px 15px 0px rgba(225, 226, 230, 0.3);
  position: sticky;
  top: 0;
  z-index: 10001;
  .item {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    cursor: pointer;
    .active-image {
      width: 20px;
      height: 8px;
      align-self: center;
      margin-top: 7px;
    }
  }
  .active {
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1a1a1a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue